export default __webpack_public_path__ + "static/portal/img/fig-3.3a6927b.png";